import request from '@/utils/request';
export function postActivityWatch(data) {
    return request({
        url: `/fund/activity/watch`,
        method: 'post',
        data
    });
}
export function postOneGang(data) {
    return request({
        url: `/fund/one/gang`,
        method: 'post',
        data
    });
}
export function getInfolist() {
    return request({
        url: `/fund/info/list`,
        method: 'GET'
    });
}
export function getRaisinglist() {
    return request({
        url: `/fund/Raising/list`,
        method: 'GET'
    });
}
